import { EServiceType } from '../../../redux/reducers';

export interface IRecommendedPackageService {
  /** Типы размещения */
  serviceType: EServiceType;
  /** Количество объявлений */
  count: number;
  /** Срок действия */
  durationInDays: number;
  /** Количество бонусов */
  auctionPoints: number;
  /** Цена */
  price: number;
}

export interface IRecommendedPackage {
  /** id пакета */
  packageId: number;
  /** автопролонгация */
  autoProlong: boolean;
  /** Текст заголовка блока рекомендованного пакета */
  headerText: string;
  /** текст хинта блока рекомендованного пакета */
  tooltipText: string;
  /** Длительность пакета в днях */
  durationInDays: number;
  /** Названия пегионов действия рекомендованного пакета */
  regionNames: string[];
  /** Название категории в карточке рекомендованного пакета */
  categoriesView: string;
  /** Цена рекомендованного пакета */
  price: number;
  /** Скидка на рекомендованного пакет */
  discountPercent: number;
  /** Цена без скидки */
  marketingPrice: number;
  /** Цена за одно объявление с учетом скидки */
  announcementPrice: number;
  /** Дата начала действия рекомендованного пакета */
  packageStartDate: string;
  /** Дата окончания действия рекомендованного пакета */
  packageEndDate: string;
  /** Общее количество объявлений в рекомендованном пакете */
  totalAnnouncementsCount: number;
  /** Общее количество бонусов в рекомендованном пакете */
  totalAuctionPointsCount: number;
  /** Признак выбора пакета */
  selected: boolean;
  /** Сервисы в рекомендованном пакете */
  services: IRecommendedPackageService[];
  /** Тип пакета */
  type: EPackageType;
  /** Полигоны пакета */
  polygonIds: number[];
}

export type TSelectedRecommendedPackageId = number | string | null;

export interface IRecommendedPackagesState {
  selectedPackageId: TSelectedRecommendedPackageId;
  packages: IRecommendedPackage[];
}

export enum EPackageType {
  /** Общее предложение (Быстрая сделка, Vip-пакет) **/
  CommonOffer = 'commonOffer',
  /** Специальное предложение - сгенерировано на основе промокода **/
  SpecialOffer = 'specialOffer',
  /** Персональное предложение - будет генерироваться на отдельных условиях **/
  PersonalOffer = 'personalOffer',
  /** Общее предложение - подписки на публикации **/
  CommonSubscription = 'commonSubscription',
  /** Смарт-пакет **/
  SmartPackage = 'smartPackage',
  /** Пакет "Всё включено" */
  AllIn = 'allIn',
  /** Подписка */
  Subscription = 'subscription',
}
